import { ROOTSTOCK } from '@/utils/networks/types';

const SUPPORTED_NETWORKS = [ROOTSTOCK];

export { SUPPORTED_NETWORKS };
